module.exports = "/_next/static/images/9a80cdfc9561fc4a32d66910ba9f284f-clips@tablet768.jpg";